module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av551-978b7b4d1dbcbca4bc7a41cdd4cb3290.jpg";